import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AuthService, StorageService} from '@cosbeni/auth';
import {filter} from 'rxjs/operators';
import * as wjcCore from '@mescius/wijmo';
import {GapiSession} from '../gapi/gapi.session';
import {LoadUserAction} from '../ngrx/actions/user.action';
import {Capability, canWith, CAPS} from '../services/roles';

/**
 * 管理画面の共有サイドバーナビ。業務ライン(神戸オークション / 買取屋 /
 * オンラインオークション)を CoreUI のアコーディオン(.nav-dropdown)で
 * エクスパンド表示し、各ラインの項目をロール(ケーパビリティ)で出し分ける。
 *
 * <p>3 シェル(admin/kobeac/kaitoriya)で同一メニューを共有するため、各シェルの
 * サイドバーはこのコンポーネントを埋め込むだけにする。現在ルートのラインは
 * 自動で開く。ログアウト/ドライブ連携もここで扱う。
 */
@Component({
    standalone: false,
    selector: 'app-workspace-nav',
    templateUrl: './workspace-nav.component.html',
})
export class WorkspaceNavComponent implements OnInit {
    user: any;
    readonly CAPS = CAPS;

    // ユーザメニュー / 管理メニューでライン別に開閉状態を分ける。
    openUserKobe = false;
    openUserKaitoriya = false;
    openAdminKobe = false;
    openAdminKaitoriya = false;
    openAdminOnline = false;
    openSystem = false;

    isGoogleSignedIn = false;
    private database: string;

    constructor(private store: Store<any>, private router: Router, private auth: AuthService,
                private storage: StorageService, private gapiSession: GapiSession) {
        this.store.dispatch(new LoadUserAction());
        this.store.select<any>('activePromotionFeature').subscribe((feature: any) => {
            if (wjcCore.isObject(feature.user) && feature.user.loaded) {
                this.user = feature.user.user;
            }
        });
        this.database = this.storage.get('database');
    }

    ngOnInit(): void {
        this.syncOpen(this.router.url);
        this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: any) => {
            this.syncOpen(e.urlAfterRedirects || e.url);
        });
    }

    /** 現在ルートの属するライン(ユーザ/管理)のアコーディオンを開く。 */
    private syncOpen(url: string): void {
        if (url.indexOf('/kobe/admin') === 0) {
            this.openAdminKobe = true;
        } else if (url.indexOf('/kobe') === 0) {
            this.openUserKobe = true;
        } else if (url.indexOf('/kaitoriya/customers') === 0 || url.indexOf('/kaitoriya/master') === 0
            || url.indexOf('/kaitoriya/users') === 0 || url.indexOf('/kaitoriya/reports') === 0) {
            this.openAdminKaitoriya = true;
        } else if (url.indexOf('/kaitoriya') === 0) {
            this.openUserKaitoriya = true;
        } else if (url.indexOf('/system') === 0) {
            this.openSystem = true;
        } else if (url.indexOf('/admin') === 0 || url.indexOf('/user') === 0) {
            this.openAdminOnline = true;
        }
    }

    can(capability: Capability | Capability[]): boolean {
        return canWith(wjcCore.isObject(this.user) ? this.user.roles : null, capability);
    }

    logout(): void {
        // token を消したあとログイン画面へ遷移する (遷移が無いと画面が
        // そのままで「ログアウトが効かない」ように見える)。
        this.auth.logout().subscribe(() => {
            this.storage.remove(this.database + '_url');
            this.router.navigate(['/login']);
        });
    }

    googleSignIn(): void {
        this.gapiSession.signIn().then(() => {
            if (this.gapiSession.isSignedIn()) {
                this.isGoogleSignedIn = true;
            }
        });
    }

    googleSignOut(): void {
        this.gapiSession.signOut();
        this.isGoogleSignedIn = false;
    }
}
